import { Route } from "@angular/router";
import { DeliveryScheduleComponent } from "./delivery-schedule.component";

export const DeliveryScheduleRouting: Route = {
    path: "schedule",
    component: DeliveryScheduleComponent,
    data: {
        breadcrumb: "Liste des Passages"
      }
}
